// components/Common/Layout.jsx
import React from 'react';
import Navigation from '../Common/header/Navigation';
import Footer from '../Common/footer/Footer';

const Layout = ({ children }) => {
    return (
        <div>
            <Navigation />
            <main>
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;